const MENSAGEM_PDF_BLOQUEADO_PELO_NAVEGADOR =
	'Não foi possível imprimir porque o navegador está configurado para baixar PDFs em vez de abri-los. ' +
	'No Chrome, acesse Configurações → Privacidade e segurança → Configurações de sites → ' +
	'Mais configurações de conteúdo → Documentos em PDF e selecione "Abrir PDFs no Chrome".'

const erroDeFrameDeOutraOrigem = (erro: unknown): boolean => {
	const { name, message } = (erro || {}) as { name?: string; message?: string }
	return name === 'SecurityError' || /cross-or[i]?gin frame/i.test(message || '')
}

export const traduzirErroDeImpressao = (erro: unknown): unknown =>
	erroDeFrameDeOutraOrigem(erro) ? new Error(MENSAGEM_PDF_BLOQUEADO_PELO_NAVEGADOR) : erro
